import moment from 'moment';
import { checkToLocaleTimeStringSupport } from './checkToLocaleStringSupport';

type FormatTimeOptions = {
    date: Date;
    locale: string;
    momentFormat?: string;
    formatOptions?: Intl.DateTimeFormatOptions;
};

const defaultMomentFormat = 'HH:MM:SS';
const defaultFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
};

function formatTime({ date, locale, momentFormat, formatOptions }: FormatTimeOptions): string {
    const toLocaleDateStringSupport = checkToLocaleTimeStringSupport();

    if (toLocaleDateStringSupport) {
        return date.toLocaleTimeString(locale, formatOptions ?? defaultFormatOptions);
    }

    return moment(date)
        .locale(locale)
        .format(momentFormat ?? defaultMomentFormat);
}

export default formatTime;
